<template>
  <li class="submenu-item">
    <slot></slot>
  </li>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class SubMenuItem extends Vue {}
</script>

<style lang="scss">
.submenu-item {
  width: 100%;
  cursor: pointer;
  transition: background 0.3s ease, color 0.1s ease;
  a {
    color: inherit;
    padding: 4px 8px;
    box-sizing: border-box;
    text-decoration: none;
    display: inline-block;
    width: 100%;
    &[disabled="true"] {
      color: #999;
    }

    &:hover:not([disabled="true"]) {
      background: linear-gradient(180deg, #404040 0%, #707070 100%);
      color: white;
    }
  }
}
</style>
